<template>
    <div>
        <v-row v-if="!isShortVersion"><v-col>Travelparty/remark</v-col></v-row>
        <v-row dense class="pb-0">
            <v-col cols="3" class="pr-2">
                <v-text-field :readonly="isReadOnly" v-model="travelparty.adults" label="Adults"></v-text-field>
            </v-col>
            <v-col cols="3" class="pr-2">
                <v-text-field :readonly="isReadOnly" v-model="travelparty.children" label="Children"></v-text-field>
            </v-col>
            <v-col cols="3" class="pr-2">
                <v-text-field :readonly="isReadOnly" v-model="travelparty.babys" label="Babys"></v-text-field>
            </v-col>
            <v-col cols="3" class="pr-2">
                <v-text-field :readonly="isReadOnly" v-model="travelparty.pets" label="Pets"></v-text-field>
            </v-col>            
        </v-row>
        <v-row dense class="mt-0">
            <v-col cols="12" class="pr-2">
                <v-textarea :readonly="isReadOnly" v-model="travelparty.remark" :rows="numRowsRemark" label="Remark"></v-textarea>
            </v-col>                
        </v-row>
    </div>
</template>

<script>
    export default {
        watch:{
            travelparty: {
                deep: true,
                handler(){
                    this.$emit('updateData', {field: 'travelparty', value: this.travelparty});
                } 
            },
        },        
        props:{
            travelparty: {
                type: Object,
                default: function() { return {adults: '0', children: '0', babys: '0', pets: '0', remark: ''}; },
            },
            isReadOnly: {
                type: Boolean,
                default: false
            },
            isShortVersion:{
                type: Boolean,
                default: false
            },            
            numRowsRemark: {
                type: Number,
                default: 3
            }
        },
        data() {
            return {
            }
        },
        methods: {
        },
    };
</script>

<style scoped>

</style>